module.exports = __webpack_public_path__ + "static/img/baccarat-guide-02.7eef535.png";